import module from 'recursoshumanos/module.js'
import template from './template.html'
import { orderBy } from 'lodash'

export class RecursoshumanosCargarmovimientosConfiguracionComponent {
  empresaId
  clasePrimaDeRiesgoId
  registroPatronalId
  registrosPatronales = []
  clasesPrimasDeRiesgo = []
  empresas = []
  onChange

  constructor ($q, RecursosHumanosEmpresas, RecursosHumanosClasePrimaDeRiesgo, RecursosHumanosClasePrimaDeRiesgoRegistroPatronales) {
    this.$q = $q
    this.RecursosHumanosEmpresas = RecursosHumanosEmpresas
    this.RecursosHumanosClasePrimaDeRiesgo = RecursosHumanosClasePrimaDeRiesgo
    this.RecursosHumanosClasePrimaDeRiesgoRegistroPatronales = RecursosHumanosClasePrimaDeRiesgoRegistroPatronales
  }

  $onChanges (changes) {
    if (changes.empresaId && changes.empresaId.isFirstChange() && changes.clasePrimaDeRiesgoId && changes.clasePrimaDeRiesgoId.isFirstChange()) {
      this.buscarRegistrosPatronales()
    }
  }

  $onInit () {
    this.RecursosHumanosClasePrimaDeRiesgo.get()
      .then(({data}) => (this.clasesPrimasDeRiesgo = data))
      .then(() => (this.validarEmpresa()))
    this.RecursosHumanosEmpresas.get()
      .then(({data}) => (this.empresas = orderBy(data.map((item) => ({
        id: item.id_empresa,
        descripcion: item.nombre,
      })), ['descripcion'])))
      .then(() => (this.validarClasePrimaDeRiesgo()))
  }

  buscarRegistrosPatronales () {
    this.notificarCambio()
    if (!this.empresaId || !this.clasePrimaDeRiesgoId) return

    this.RecursosHumanosClasePrimaDeRiesgoRegistroPatronales.get(this.empresaId, this.clasePrimaDeRiesgoId)
      .then(({data}) => (this.registrosPatronales = data))
      .then(() => (this.validarRegistroPatronal()))
  }

  notificarCambio () {
    this.onChange({
      $event: {
        data: {
          empresaId: this.empresaId,
          clase: this.clasePrimaDeRiesgoId,
          registroPatronalId: this.registroPatronalId,
        },
      },
    })
  }

  validarEmpresa () {
    if (!this.empresas.length) return
    if (this.empresaId && !this.empresas.map((item) => item.id).includes(this.empresaId)) {
      this.empresaId = undefined
      this.clasePrimaDeRiesgoId = undefined
      this.registroPatronalId = undefined
    }
  }

  validarClasePrimaDeRiesgo () {
    if (!this.clasesPrimasDeRiesgo.length) return
    if (this.clasePrimaDeRiesgoId && (!this.empresaId || !this.clasesPrimasDeRiesgo.map((item) => item.id).includes(this.clasePrimaDeRiesgoId))) {
      this.clasePrimaDeRiesgoId = undefined
    }
  }

  validarRegistroPatronal () {
    if (!this.registrosPatronales.length) return
    if (this.registroPatronalId && (!this.registrosPatronales.map(i => i.id).includes(this.registroPatronalId))) {
      this.registroPatronalId = undefined
      this.notificarCambio()
    }
  }

}

module.component('recursoshumanosCargarmovimientosConfiguracion', {
  controller: RecursoshumanosCargarmovimientosConfiguracionComponent,
  template,
  bindings: {
    empresaId: '<',
    clasePrimaDeRiesgoId: '<',
    registroPatronalId: '<',
    onChange: '&',
  },
})



// WEBPACK FOOTER //
// ./src/recursoshumanos/components/cargarmovimientos/configuracion/component.js